"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Condition_1 = require("./_Condition");
var _Redirect_1 = require("./_Redirect");
exports._RoutingRule = {
    type: "structure",
    required: ["Redirect"],
    members: {
        Condition: {
            shape: _Condition_1._Condition
        },
        Redirect: {
            shape: _Redirect_1._Redirect
        }
    }
};
//# sourceMappingURL=_RoutingRule.js.map